import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerRightDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-right-down"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerRightDown"><path fillRule="evenodd" clipRule="evenodd" d="M4 4H14.5V19.2929L10.5 15.2929L9.79289 16L15 21.2071L20.2071 16L19.5 15.2929L15.5 19.2929V3H4V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerRightDown;
